<script setup lang="ts">
/**
 * FAQ band for a marketing subpage.
 *
 * Takes the items rather than building them, so the page that renders it can
 * hand the same array to `faqPageNode` and the markup and the structured data
 * can never drift apart.
 */
import type { SofaxAccordionItem } from '~/components/sofax/Accordion.vue'

withDefaults(defineProps<{
  title: string
  items: SofaxAccordionItem[]
  /** Shared <details name>, so only one answer is open at a time. */
  name?: string
}>(), {
  name: 'marketing-faq',
})
</script>

<template>
  <section id="faq" class="sofax surface-alt">
    <div class="section-space">
      <div class="shell">
        <div class="mx-auto mb-10 max-w-2xl text-center md:mb-[3.75rem] lg:mb-20">
          <h2>{{ title }}</h2>
        </div>

        <SofaxAccordion :items="items" :columns="2" :default-open="0" :name="name" />
      </div>
    </div>
  </section>
</template>
